import { Injectable } from '@angular/core';
import { NCashData } from '../../model/finzy-flex/nCash.model';
import { AttributeValue } from '../../model/finzy-flex/user-attribute.model';
import { AccountService } from '../../service/finzy-flex/account/account.service';
import { Keys, StorageService } from '../../service/storage.service';

@Injectable()
export class NCashDataUtil {
    private readonly accountService: AccountService;
    private readonly storageService: StorageService;
    constructor(accountService: AccountService, storageService: StorageService) {
        this.accountService = accountService;
        this.storageService = storageService;
    }

    private static nCashAttributes = new Map<AttributeValue, string>()
        .set(AttributeValue.MAX_LIMIT, 'maxNcash')
        .set(AttributeValue.INTEREST_ONLY, 'interestOnly')
        .set(AttributeValue.CUSTOM, 'customNcash')
        .set(AttributeValue.MONTHLY, 'MONTHLY')
        .set(AttributeValue.QUARTERLY, 'QUARTERLY')
        .set(AttributeValue.SEMI_ANNUALLY, 'SEMI_ANNUALLY')
        .set(AttributeValue.ANNUALLY, 'ANNUALLY')

    private static getNCashAttributes(nCashAttribute: any): string {
        if (this.nCashAttributes.has(nCashAttribute)) {
            return this.nCashAttributes.get(nCashAttribute);
        } else {
            return '';
        }
    }

    private getLenderId(): string {
        return this.storageService.getItem(Keys.LENDER_ID);
    }

    public async getNCashDetailsByLenderId(nCashType: string, ncashFrequency: string, ncashDateSelection: number): Promise<NCashData> {
        return await this.accountService.getNCashDetails(this.getLenderId(), NCashDataUtil.getNCashAttributes(nCashType),
            NCashDataUtil.getNCashAttributes(ncashFrequency), ncashDateSelection);
    }

    public async getNCashDetailsWithDefaultValue(): Promise<NCashData> {
        return await this.accountService.getNCashDetails(this.getLenderId());
    }
}
